import React from "react";
import Newnabar from "../components/shared/Newnabar";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import FaqSection from "../components/faq/FaqSection";

// Agar apni custom image lagani ho toh yahan import karo:
// import myFaqImage from "../assets/my-custom-faq.png";

export default function Faq() {
  return (
    <div className="flex flex-col min-h-screen pt-16">
      <Newnabar />

      <main className="flex-1 flex flex-col">
       
        <FaqSection heroImage="/img/faq/faq.svg" />
      </main>

      <div className="hidden md:block">
        <SoloConnectFooter />
      </div>

      <div className="block md:hidden">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
